export const worksheets = {
  title: 'Worksheets',
  subtitle: 'Template-based worksheet management with digital signatures',
  new: 'New Worksheet',
  edit: 'Edit Worksheet',
  view: 'View Worksheet',
  delete: 'Delete Worksheet',
  
  // Status
  status: {
    draft: 'Draft',
    assigned: 'Assigned',
    in_progress: 'In Progress',
    review_pending: 'Review Pending',
    completed: 'Completed',
    sent: 'Sent',
    partially_invoiced: 'Partially Invoiced',
    invoiced: 'Invoiced',
    cancelled: 'Cancelled',
    hibernated: 'Hibernated'
  },
  
  // Work types
  workTypes: {
    installation: 'Installation',
    maintenance: 'Maintenance',
    repair: 'Repair',
    inspection: 'Inspection',
    other: 'Other'
  },
  
  // Priority
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
  },
  
  // Fields
  fields: {
    title: 'Worksheet Title',
    description: 'Description',
    customer: 'Customer',
    workType: 'Work Type',
    status: 'Status',
    priority: 'Priority',
    dueDate: 'Due Date',
    location: 'Location',
    workDetails: 'Work Details',
    materials: 'Materials',
    equipment: 'Equipment',
    safetyNotes: 'Safety Notes',
    estimatedHours: 'Estimated Hours',
    actualHours: 'Actual Hours',
    signatures: 'Signatures',
    documents: 'Documents',
    worksheetDate: 'Worksheet Date',
    startTime: 'Start Time',
    endTime: 'End Time',
    travelInfo: 'Travel Information',
    travelKmStart: 'Start km',
    travelKmEnd: 'End km',
    travelKmTotal: 'Total',
    travelCosts: 'Travel Costs',
    deploymentInfo: 'Deployment Information',
    deployment: 'Deployment',
    deploymentOccurred: 'Deployment occurred',
    deploymentDate: 'Deployment Date',
    deploymentTime: 'Deployment Time',
    deploymentYes: 'Completed',
    materialsAndEquipment: 'Materials & Equipment',
    specialNotes: 'Special Notes',
    unknownCustomer: 'Unknown customer',
    deploymentAndTravel: 'Deployment & Travel',
    additionalInfo: 'Additional Information',
    additionalNotesPlaceholder: 'Additional notes, observations...',
    totalKm: 'Total km traveled',
    travelCostFt: 'Travel cost (Ft)',
    save: 'Save',
    cancel: 'Cancel'
  },
  
  // Actions
  actions: {
    create: 'Create',
    edit: 'Edit',
    view: 'View',
    delete: 'Delete',
    complete: 'Complete',
    sign: 'Sign',
    addSignature: 'Add Signature',
    add: 'Add',
    close: 'Close',
    print: 'Print',
    downloadPdf: 'Download PDF'
  },
  
  // Messages
  messages: {
    noWorksheets: 'No worksheets',
    noWorksheetsDescription: 'Get started by creating your first worksheet.',
    createSuccess: 'Worksheet created successfully',
    createError: 'Error creating worksheet',
    updateSuccess: 'Worksheet updated successfully',
    updateError: 'Error updating worksheet',
    deleteSuccess: 'Worksheet deleted successfully',
    deleteError: 'Error deleting worksheet',
    confirmDelete: 'Are you sure you want to delete this worksheet?',
    confirmTitle: 'Delete Worksheet',
    deleteQuestion: 'Are you sure you want to delete this worksheet?',
    deleteWarning: 'This action cannot be undone!',
    signatureAdded: 'Signature added successfully',
    signatureError: 'Error adding signature',
    signatureRemoved: 'Signature removed',
    signatureRemoveError: 'Error removing signature',
    completed: 'Worksheet completed',
    completedError: 'Error completing worksheet',
    noSignatures: 'No signatures',
    printBlocked: 'Popup blocked - please allow popups to print',
    pdfSuccess: 'PDF downloaded successfully',
    pdfError: 'Error generating PDF'
  },
  
  // Filters
  filters: {
    all: 'All',
    allTypes: 'All Types',
    byStatus: 'By Status',
    byType: 'By Type'
  },
  
  // Items
  items: {
    title: 'Items',
    name: 'Description',
    quantity: 'Qty',
    unit: 'Unit',
    unitPrice: 'Unit Price',
    vat: 'VAT',
    netTotal: 'Net',
    grossTotal: 'Gross',
    total: 'Total:',
    net: 'Net:',
    gross: 'Gross:',
    add: 'Add Item',
    remove: 'Remove',
    headerPlaceholder: 'Header name...',
    namePlaceholder: 'Description...',
    empty: 'No items added yet. Click the buttons above.'
  },
  
  // Tasks
  tasks: {
    title: 'Tasks',
    completed: 'done',
    add: 'Add Task',
    progress: '{completed}/{total} done'
  },
  
  // Time tracking
  timeTracking: {
    title: 'Time Tracking',
    start: 'Start',
    stop: 'Stop',
    manual: 'Manual Entry',
    startLabel: 'Start',
    endLabel: 'End',
    workers: 'workers',
    description: 'Description',
    duration: 'Duration',
    type: 'Type',
    manualType: 'Manual',
    timerType: 'Timer',
    workersCount: 'Workers',
    add: 'Add',
    personTimes: '× person',
    noEntries: 'No time entries recorded yet.'
  },
  
  // Notes
  notes: {
    title: 'Notes',
    add: 'Add Note',
    customer: 'Visible to customer',
    internal: 'Internal',
    placeholder: 'Type your note here...',
    remove: 'Delete'
  },
  
  // Print
  print: {
    title: 'WORKSHEET',
    subtitle: 'YouCRM - Your CRM System',
    generatedAt: 'Generated:',
    basicInfo: 'Basic Information',
    workTime: 'Work Time',
    domain: 'youcrm.hu'
  },
  
  // Quick dates
  quickDates: {
    day1: '+1 day',
    day3: '+3 days',
    day5: '+5 days',
    day8: '+8 days',
    week1: '+1 week',
    week2: '+2 weeks',
    month1: '+1 month'
  },
  
  // Templates
  templates: {
    title: 'Worksheet Templates',
    new: 'New Worksheet Template',
    name: 'Template Name',
    nameRequired: 'Template name is required',
    noOrganization: 'No organization',
    loading: 'Loading...',
    empty: 'No templates created yet.',
    confirmDelete: 'Are you sure you want to delete this template?',
    category: 'Category',
    estimatedHours: 'Estimated Hours',
    priority: 'Priority',
    defaultItems: 'Default Items',
    addItem: '+ Item',
    defaultTasks: 'Default Tasks',
    addTask: '+ Task',
    taskName: 'Task name',
    minutes: 'min',
    create: 'Create Template',
    cancel: 'Cancel',
    description: 'Description',
    itemsCount: 'items',
    tasksCount: 'tasks',
    categoryName: {
      installation: 'Installation',
      maintenance: 'Maintenance',
      repair: 'Repair',
      inspection: 'Inspection',
      other: 'Other'
    }
  }
}; 